var _path, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnselectedChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M14.7214 0.71167H9.19166C6.05318 0.71167 3.36304 3.21785 3.36304 6.31372V21.7931L0.374008 26.9529H14.7214C17.8599 26.9529 20.55 24.4467 20.55 21.2034V6.46114C20.55 3.21785 18.0093 0.71167 14.7214 0.71167ZM18.3082 21.3508C18.3082 23.2673 16.6643 24.7415 14.8708 24.7415H5.75427V6.46114C5.75427 4.54465 7.39824 3.07043 9.19166 3.07043H14.7214C16.6643 3.07043 18.1588 4.69207 18.1588 6.46114V21.3508H18.3082Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6181 8.37769H8.44441V10.589H15.6181V8.37769Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6181 12.3579H8.44441V14.5692H15.6181V12.3579Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6181 16.3384H8.44441V18.5497H15.6181V16.3384Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedChat);
export default __webpack_public_path__ + "static/media/unselected-chat.c205ef343c74e2762ec91e662140578b.svg";
export { ForwardRef as ReactComponent };